$('#topslide').slick({
  autoplay: true,
  infinite: true,
  centerMode: true,
  slidesToShow: 1,
  centerPadding: "20%",
  dots: true,
  arrows: false,
  responsive: [
    {
      breakpoint: 769,//モニターの横幅が769px以下の見せ方
      settings: {
  centerPadding: "7%",
      }
    }
  ]
});